<template>
  <div class="row"><div style="display: flex; justify-content: space-between; padding: 0;">
    <div class="col-8 float-start">
      <input
        :id="getFieldID(schema)"
        v-attributes="'input'"
        :data-test="getFieldID(schema)"
        class="form-control w-100"
        type="file"
        :name="schema.inputName"
        :accept="schema.accept"
        :multiple="schema.multiple"
        :placeholder="schema.placeholder"
        :readonly="schema.readonly"
        :required="schema.required"
        :disabled="disabled"
        @change="onChange"
      />
    </div>
    <div class="col-4 float-end">
      <span v-if="uploadedFileName">
        <button id="download" data-test="download" class="btn btn-secondary float-end" @click.prevent="download">
          <i class="fas fa-download"></i>
          {{ $t('network.download') }}
        </button>
      </span>
    </div>
    </div>
    <div v-if="uploading" class="text-center mt-4">
      <i class="fas fa-upload"></i>
      <p>{{ $t('Create.uploading') }}</p>
      <i class="fas fa-spinner"></i>
    </div>
  </div>
</template>
<script>
import { baseName } from '@/lib/util.js';
import { abstractField } from 'vue-form-generator';
import isFunction from 'lodash/isFunction';

//This component implements a S3 Upload component, and updates the value
export default {
  name: 'field-s3-upload',
  mixins: [abstractField],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    schema: {
      type: Object,
      default: null,
    },
    model: {
      type: Object,
      default: null,
    },
    formOptions: {
      type: Object,
      default: null,
    },
    vfg: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      uploading: false,
      uploaded: false,
      s3: {}, // s3 parameters
    };
  },
  computed: {
    uploadedFileName() {
      var name = baseName(this.value);
      if (name == 'null') return false;
      return name;
    },
  },
  methods: {
    onChange($event) {
      if ($event.target.files.length == 0) {
        return console.log('No files selected');
      }

      this.uploading = true;

      // only take the first file
      var file = $event.target.files[0];

      if (this.schema.s3.type == "people" && file.type != "application/pdf") {
        this.uploading = false;
        this.$swal.fire({
          icon: 'error',
          title: 'Only PDF files are supported.',
        });
      } else {
        this.$http.post('s3/upload-params', this.schema.s3).then(resp => {
          this.s3 = resp.data;

          // do the full upload here... (why wait anyway)
          var upload_path = this.s3.uploadPathPrefix;
          var fullFilePath = upload_path + '/' + file.name;

          // prepare formdata
          let formData = new FormData();
          for (let key in this.s3.formInputs) {
            if (key == 'key') continue;
            formData.append(key, this.s3.formInputs[key]);
          }
          formData.append('key', fullFilePath);
          formData.append('file', file);

          return this.$http
            .post(this.s3.formAttributes.action, formData, {
              headers: {
                Authorization: '',
              },
            })
            .then(() => {
              this.uploading = false;
              this.uploaded = true;
              this.value = fullFilePath;
              this.$emit('input', fullFilePath);

              if (isFunction(this.schema.onUploaded)) {
                // Schema has defined onChange method.
                this.schema.onUploaded.call(this, this.model, this.schema, $event, this);
              }
            })
            .catch(() => {
              this.uploading = false;
            });
        })
        .catch(err => {
          this.$bvModal.msgBoxOk(this.$t('s3-upload-initialization-failed-please-check-console-for-details-or-refresh-the-page-to-try-again'));
          console.log('get s3 upload params failed', err);
          this.busy = false;
        });
      }

      if (isFunction(this.schema.onChange)) {
        // Schema has defined onChange method.
        this.schema.onChange.call(this, this.model, this.schema, $event, this);
      }
    },

    // let users download this file
    async download() {
      var file = await this.$http.post('/s3/base-url', { file: this.value }).then(resp => {
        return resp.data;
      });
      console.log('file was:', file);
      window.location.href = file;
    },
  },
};
</script>
